import React from 'react';
import { di } from 'react-magnetic-di';
import Icon from '@atlaskit/icon';
import CreateRuleIcon from '@atlaskit/icon/glyph/add';
import AuditLogIcon from '@atlaskit/icon/glyph/check-circle-outline';
import { LinkItem, Section } from '@atlaskit/menu';
import { ManageRulesGlyph, MenuIcon } from '../../common/ui/icon';
import messages from './messages';
/**
 * baseAutomationUrl - the host url you'd like the create/manage automations links to route to
 * createAutomationComponentFilter - optional category string to apply as a filter when routing
 * the create automation button
 * onCreateAutomationFooterLinkClicked - is called when create automation is clicked
 * onManageAutomationsFooterLinkClicked - is called when manage automations is clicked
 * onAuditLogFooterLinkClicked - is called when audit log is clicked
 * */

const handleOptionalCallback = optionalEvent => {
  if (optionalEvent) {
    optionalEvent();
  }
};
export default (({
  baseAutomationUrl,
  createAutomationComponentFilter,
  onCreateAutomationFooterLinkClicked,
  onManageAutomationsFooterLinkClicked,
  onAuditLogFooterLinkClicked
}) => {
  const componentFilter = createAutomationComponentFilter ? `?componentFilterCriteria=${createAutomationComponentFilter}` : '';
  const createNewRuleUrl = `${baseAutomationUrl}#/rule/new/__NEW__TRIGGER${componentFilter}`;
  return /*#__PURE__*/React.createElement(Section, {
    hasSeparator: true,
    isList: true
  }, /*#__PURE__*/React.createElement(LinkItem, {
    onClick: () => handleOptionalCallback(onCreateAutomationFooterLinkClicked),
    href: createNewRuleUrl,
    testId: "create-automation-link",
    iconBefore: /*#__PURE__*/React.createElement(MenuIcon, null, /*#__PURE__*/React.createElement(CreateRuleIcon, {
      size: "small",
      label: ""
    }))
  }, messages.createAutomationItem.defaultMessage), /*#__PURE__*/React.createElement(LinkItem, {
    onClick: () => handleOptionalCallback(onManageAutomationsFooterLinkClicked),
    href: baseAutomationUrl,
    testId: "manage-automations-link",
    iconBefore: /*#__PURE__*/React.createElement(MenuIcon, null, /*#__PURE__*/React.createElement(Icon, {
      size: "small",
      glyph: ManageRulesGlyph,
      label: ""
    }))
  }, messages.manageAutomationsItem.defaultMessage), /*#__PURE__*/React.createElement(LinkItem, {
    onClick: () => {
      handleOptionalCallback(onAuditLogFooterLinkClicked);
    },
    href: `${baseAutomationUrl}#tab/audit-log`,
    testId: "audit-log-link",
    iconBefore: /*#__PURE__*/React.createElement(MenuIcon, null, /*#__PURE__*/React.createElement(AuditLogIcon, {
      size: "small",
      label: ""
    }))
  }, messages.auditLogItem.defaultMessage));
});